import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface UpdateCustomerRequest {
    manager_name: string;
    manager_mobile: string;
    manager_email: string | null;
}

export const usePutCustomerManager = (
    successCallback?: () => void,
    customerId?: number,
    managerId?: number,
): UseMutationResult<null, Error, UpdateCustomerRequest> => {
    const queryClient = useQueryClient();
    const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<null, Error, UpdateCustomerRequest>({
        mutationFn: async (customerManagerData: UpdateCustomerRequest) => {
            try {
                const response = await axios.put(
                    enum_api_uri.put_customer_manager
                        .replace(":customer_idx", customerId?.toString() || "")
                        .replace(":customer_manager_idx", managerId?.toString() || ""),
                    customerManagerData,
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                        },
                    },
                );
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ["getCustomerManager"] });
            queryClient.invalidateQueries({ queryKey: ["getCustomerList"] });
            successCallback?.();
        },
    });
};
